import { useMemo } from "react";
import {
  BurnEvent,
  BurnNonSensitiveUi,
  BurnTemperatureSeriesNonSensitive,
} from "firefly-shared-ts-domain";
import { useTranslation } from "react-i18next";

export const useSelectedBurnTemperatureSeries = (
  burns: Array<BurnNonSensitiveUi> | undefined,
  burnTemperatureSeries: Array<BurnTemperatureSeriesNonSensitive> | undefined,
  burnColors: Array<string> | undefined,
  selectedBurnIndexes: boolean[] | undefined
): {
  selectedBurns: Array<BurnNonSensitiveUi> | undefined;
  selectedBurn: BurnNonSensitiveUi | undefined;
  selectedBurnEvents: Array<BurnEvent[]> | undefined;
  selectedBurnTemperatureSeries:
    | Array<BurnTemperatureSeriesNonSensitive>
    | undefined;
  selectedBurnColors: Array<string | undefined> | undefined;
  selectedBurnDisplayNames: Array<string> | undefined;
} => {
  const { t } = useTranslation("firefly-shared-ts-domain");
  return useMemo(() => {
    if (burns === undefined || burnTemperatureSeries === undefined) {
      return {
        selectedBurns: undefined,
        selectedBurn: undefined,
        selectedBurnEvents: undefined,
        selectedBurnTemperatureSeries: undefined,
        selectedBurnColors: undefined,
        selectedBurnDisplayNames: undefined,
      };
    }

    const selectedBurns: Array<BurnNonSensitiveUi> = [];
    const selectedBurnEvents: Array<BurnEvent[]> = [];
    const selectedBurnTemperatureSeries: Array<BurnTemperatureSeriesNonSensitive> =
      [];
    const selectedBurnColors: Array<string | undefined> = [];
    const selectedBurnDisplayNames: Array<string> = [];
    let selectedBurn: BurnNonSensitiveUi | undefined;
    burnTemperatureSeries?.forEach((it, index) => {
      const burn = burns?.[index];

      if (selectedBurnIndexes?.[index] ?? false) {
        selectedBurns.push(burn);
        selectedBurnDisplayNames.push(
          `${t("Burn")} #${burn?.orderOfOccurence?.toString()}`
        );
        selectedBurnTemperatureSeries.push(it);
        const burnColor = burnColors?.[index];
        selectedBurnColors.push(burnColor);
        selectedBurn = burn;
      }
    });
    if (selectedBurns.length === 1) {
      selectedBurnEvents.push(selectedBurns[0].burnEvents);
    }
    if (selectedBurns.length > 1) {
      selectedBurn = undefined;
    }
    return {
      selectedBurns: selectedBurns,
      selectedBurn: selectedBurn,
      selectedBurnEvents: selectedBurnEvents,
      selectedBurnTemperatureSeries: selectedBurnTemperatureSeries,
      selectedBurnColors: selectedBurnColors,
      selectedBurnDisplayNames: selectedBurnDisplayNames,
    };
  }, [burns, burnTemperatureSeries, burnColors, selectedBurnIndexes, t]);
};
